import { Button } from '@fattureincloud/fic-design-system'
import React, { FC } from 'react'

import { locale } from '../../locales/locale'
import { HelpModal, Table, TableData, TableRow } from '../common.components'
import { NegativeComment } from '../definitions'

interface Props {
    data: NegativeComment[]
    isOpen: boolean
    setIsOpen: (status: boolean) => void
}

const NegativeCommentsModal: FC<Props> = (props: Props) => {
    return (
        <HelpModal
            title={locale('Commenti Negativi')}
            isOpen={props.isOpen}
            onActionClose={() => props.setIsOpen(false)}
            footer={() => (
                <>
                    <Button
                        text={locale('Chiudi')}
                        color={'grey'}
                        onClick={() => {
                            props.setIsOpen(false)
                        }}
                    />
                </>
            )}
        >
            <>
                <Table id={'negativeComments'}>
                    <thead>
                        <tr>
                            <th>{locale('Data')}</th>
                            <th>UID</th>
                            <th>{locale('Commento')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.data.map((c) => {
                            return (
                                <TableRow key={String(c.id)}>
                                    <TableData>{c.date}</TableData>
                                    <TableData>{c.company_id}</TableData>
                                    <TableData wrap={true}>{c.feedback_comment}</TableData>
                                </TableRow>
                            )
                        })}
                    </tbody>
                </Table>
            </>
        </HelpModal>
    )
}

export default NegativeCommentsModal